import React, { useMemo, useState } from "react";

function ConsentResponsePage() {
  const params = useMemo(() => new URLSearchParams(window.location.search), []);
  const token = params.get("token") || "";
  const presetDecision = (params.get("decision") || "").toLowerCase();

  const [status, setStatus] = useState("idle");
  const [message, setMessage] = useState("");

  const apiBase = process.env.REACT_APP_API_BASE_URL;

  const submitDecision = async (decision) => {
    if (!token) {
      setStatus("error");
      setMessage("Missing consent token. Please use the full link from your email.");
      return;
    }

    try {
      setStatus("loading");
      setMessage("");

      const res = await fetch(`${apiBase}/api/looks/consent/respond`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ token, decision, channel: "email" }),
      });

      const data = await res.json();
      if (!res.ok) {
        throw new Error(data?.message || "Unable to record your preference");
      }

      setStatus("success");
      setMessage(
        decision === "approved"
          ? "Thank you. Your consent has been recorded."
          : "Your preference has been recorded. This look will not be shared publicly.",
      );
    } catch (err) {
      setStatus("error");
      setMessage(err.message || "Unable to record your preference");
    }
  };

  React.useEffect(() => {
    if (presetDecision === "approved" || presetDecision === "declined") {
      submitDecision(presetDecision);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [presetDecision]);

  return (
    <div
      style={{
        minHeight: "100vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        background: "#f9fafb",
        padding: "20px",
      }}
    >
      <div
        style={{
          width: "100%",
          maxWidth: "560px",
          background: "#ffffff",
          border: "1px solid #e5e7eb",
          borderRadius: "16px",
          padding: "28px",
        }}
      >
        <h1 style={{ marginTop: 0, marginBottom: "8px", fontSize: "24px" }}>Photo Consent</h1>
        <p style={{ marginTop: 0, color: "#6b7280", fontSize: "14px" }}>
          Please confirm whether you allow this service result photo to be used on OGESTYLE.
        </p>

        {status === "loading" && <p>Saving your preference...</p>}

        {(status === "success" || status === "error") && (
          <div
            style={{
              marginBottom: "14px",
              padding: "10px 12px",
              borderRadius: "8px",
              border: status === "success" ? "1px solid #86efac" : "1px solid #fecaca",
              background: status === "success" ? "#f0fdf4" : "#fef2f2",
              color: status === "success" ? "#166534" : "#991b1b",
            }}
          >
            {message}
          </div>
        )}

        {presetDecision !== "approved" && presetDecision !== "declined" && status !== "success" && (
          <div style={{ display: "flex", gap: "10px", marginTop: "12px" }}>
            <button
              onClick={() => submitDecision("approved")}
              disabled={status === "loading"}
              style={{
                padding: "10px 14px",
                borderRadius: "8px",
                border: "1px solid #86efac",
                background: "#f0fdf4",
                color: "#166534",
                fontWeight: 600,
                cursor: status === "loading" ? "not-allowed" : "pointer",
              }}
            >
              Approve
            </button>
            <button
              onClick={() => submitDecision("declined")}
              disabled={status === "loading"}
              style={{
                padding: "10px 14px",
                borderRadius: "8px",
                border: "1px solid #fecaca",
                background: "#fef2f2",
                color: "#991b1b",
                fontWeight: 600,
                cursor: status === "loading" ? "not-allowed" : "pointer",
              }}
            >
              Decline
            </button>
          </div>
        )}
      </div>
    </div>
  );
}

export default ConsentResponsePage;
